import { getDisclaimer } from 'config/api';
import { useQuery } from 'react-query';

export type DisclaimerProps = {
  ID: string;
  notificationID: string | null;
  title: string | null;
  content: string | null;
  agreed: boolean;
  externalLink: boolean;
  updTime: string;
  notification: {
    ID: string;
    type: number;
    title: string;
    content: string;
    insTime: string;
    updTime: string | null;
  } | null;
};

export type Agreed = {
  id: string;
  agreed: boolean;
};

export const getAgreedStorage = (): Agreed[] | null => {
  const userJson = sessionStorage.getItem('agreed');
  return userJson ? (JSON.parse(userJson) as Agreed[]) : null;
};

export const setAgreedStorage = (list: Agreed[]) => {
  sessionStorage.setItem('agreed', JSON.stringify(list));
};

export const useDisclaimer = () => {
  const { data, isLoading, isRefetching } = useQuery(
    'getDisclaimer',
    () => getDisclaimerAPI(),
    {
      refetchOnWindowFocus: false,
    }
  );

  return { disclaimers: data, isLoading, isRefetching };
};

export const getDisclaimerAPI = async (): Promise<DisclaimerProps[]> => {
  const ret_ = await getDisclaimer();
  const ret = ret_.Items.map(item => {
    return {
      ID: item.ID,
      notificationID: item.NotificationID,
      title: item.Title,
      content: item.Content,
      agreed: item.Agreed,
      externalLink: item.ExternalLink,
      updTime: item.UpdTime,
      notification: !item.Notification
        ? null
        : {
            ID: item.Notification.ID,
            type: item.Notification.Type,
            title: item.Notification.Title,
            content: item.Notification.Content,
            insTime: item.Notification.InsTime,
            updTime: item.Notification.UpdTime,
          },
    };
  }) as DisclaimerProps[];

  return ret;
};
